import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { UseModalContext, ModalContext, useList } from '@prometheus/hooks';
import { setBreadcrumbs } from '@prometheus/redux';
import { getDescriptorId, getDescriptors } from '@/api/admin';
import { CodeEditor, SpinnerContainer } from '@prometheus/features';
import { Table, Spinner, Grid } from '@prometheus/components';
import { colsTableEnviroments } from './Environments.config';

export const EnviromentsList: React.FC<any> = ({ root }) => {
  const dispatch = useDispatch();
  const { openModal, closeModal } = useContext<UseModalContext>(ModalContext);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          name: t('breadcrumbs.admin'),
          path: `${root.rootPath}`,
        },
        {
          name: t('breadcrumbs.envs'),
          path: `${root.rootPath}/environments`,
        },
      ])
    );
  }, [dispatch]);

  const { data: descriptors } = useList({
    primaryKey: 'id',
    autoLoad: true,
    methods: {
      read: {
        method: () => getDescriptors(),
      },
    },
  });

  const loadDescriptor = async id => {
    try {
      const result = await getDescriptorId(id);
      onOpen(result.json);
    } catch (e) {
      console.log(e);
    }
  };

  const onOpen = data => {
    openModal(
      () => (
        <CodeEditor
          data={data || ''}
          height={'85vh'}
          containerStyles={{ padding: 0 }}
          enableDownload={true}
          language="json"
          enableCopy
          readOnly
        />
      ),
      t('modals.show_descriptor_header'),
      {
        closeOnClickOutside: true,
        onClose: closeModal,
      }
    );
  };

  const cols = React.useMemo(
    () => colsTableEnviroments(t, loadDescriptor),
    [t]
  );

  if (!(descriptors?.ids.length > 0)) {
    return (
      <SpinnerContainer>
        <Spinner size={62} />
      </SpinnerContainer>
    );
  }

  return (
    <Grid containet px={6} flexGrow={1} flexDirection="column">
      <Grid item xs={12}>
        <Table
          columns={cols}
          data={Object.values(descriptors.byId)}
          loadingMessage={''}
          enableSorting
          enablePagination
          totalElements={descriptors?.length}
          onEdit={() => {}}
        />
      </Grid>
    </Grid>
  );
};
